import { useMemo } from 'react';
import { applyLocalizedStandardLabels } from '../lib/localizeStandardExercises';
import { useI18n } from './context';

/** Catalog from API + localized `label` for type==='standard' when locale is en/es. */
export function useLocalizedExerciseOptions(allExercises) {
  const { t, locale } = useI18n();
  return useMemo(
    () => applyLocalizedStandardLabels(allExercises, t, locale),
    [allExercises, t, locale]
  );
}
